// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldPropertiesAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withProps = require('recompose').withProps;
  var CalculatedField = require('share/components/controls/calculatedField/Izenda.CalculatedField');
  var constants = require('logic/data/Izenda.ReportDesignerConstants');
  var PopupInputUIState = require('logic/models/Izenda.PopupInputUIState');
  var ReportPartFieldConstants = require('logic/data/Izenda.ReportPartFieldConstants');
  var GRID_STYLES = require('logic/data/Izenda.ReportPartGridConstants').GRID_STYLES;
  const { curry, get, includes, forEach } = require('lodash/fp');
  const SORT_ORDERS = ReportPartFieldConstants.SORT_ORDERS;
  var CalculatedFieldPropertiesAction = compose(
    withProps(function() {
      return {
        uiState: new PopupInputUIState()
      };
    }),
    withHandlers({
      showPopup: curry(showPopup),
      fnResetDefaultValue: curry(fnResetDefaultValue)
    })
  );

  /**
   * Show popup
   * @param  {Object} props Component properties
   * @param  {Object} e     react event
   * @return {Object}       Data
   */
  function showPopup(props, e) {
    if (props.onClick && !props.onClick(e)) {
      return;
    }

    /**
     * Action when close popup
     * @param  {Object} calculatedData     apply dât
     */
    var closeCalculatedPopup = function(calculatedData) {
      if (calculatedData) {
        props.onChange && props.onChange({ value: calculatedData });
        props.afterOnChange && props.afterOnChange(calculatedData, SORT_ORDERS.ASC);
        props.uiState.update(props);
      }
    };

    var checkCanNotSetSubtotal = function(configReportPart, configField) {
      var reportPartContent = configReportPart.reportPartContent;
      var isGridReportPart = configReportPart.type === constants.REPORT_PART_TYPE.Grid;
      var isGridPivot =
        isGridReportPart && get('properties.generalInfo.gridStyle', reportPartContent) === GRID_STYLES.PIVOT.value;

      return (
        (isGridReportPart && includes(configField, get('separators.elements', reportPartContent))) ||
        (isGridPivot && includes(configField, get('columns.elements', reportPartContent)))
      );
    };

    var value = props.uiState.value || {};
    var label = value.label || value.name;
    var functionName = value.function || value.functionName;
    var izendaDataType = value.dataType || value.izendaDataType;

    var data = props.fieldStore.masterModel;
    var configReportPart = data.configReportPart;
    var configField = configReportPart.configField;
    var selectedField = configReportPart.fieldCollection;
    var hasSupportDefaultTotal = get('field.hasSupportDefaultTotal', configField);
    var formatDataType = get('properties.dataFormattings.functionInfo.formatDataType', configField) || '';
    var canSetSubtotal = !checkCanNotSetSubtotal(configReportPart, configField);
    var fieldList = [];

    selectedField &&
      forEach(function(item) {
        item.field.visible &&
          fieldList.push({
            name: item.field.fieldNameAlias,
            description: item.field.expression,
            dataType: item.field.dataFieldType,
            fieldId: item.field.fieldId,
            schemaName: item.field.schemaName,
            querySourceName: item.field.querySourceName,
            databaseName: item.field.databaseName
          });
      }, selectedField);

    props.fieldStore.fillCalculatedFieldData(null, fieldList, false);

    var calculatedStore = props.fieldStore.calculatedStore;
    var selectedDataSourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();

    if (props.isSubTotalSetting && !props.uiState.hadSetting) {
      label = String.format('Subtotal {0}', props.fieldSetting);
    }

    var initialData = {
      name: label,
      functionName: functionName,
      expression: value.expression,
      izendaDataType: izendaDataType,
      format: value.format,
      querySourceId: value.querySourceId,
      fieldDataType: value.fieldDataType,
      previewResult: value.previewResult,
      previewRecord: value.previewRecord,
      hasSupportDefaultTotal: hasSupportDefaultTotal,
      formatDataType: formatDataType,
      canSetSubtotal: canSetSubtotal
    };

    return props.openPopup(CalculatedField, {
      reportPart: data.configReportPart,
      reportDesigner: data,
      store: props.fieldStore.calculatedStore,
      onClose: closeCalculatedPopup,
      type: props.type,
      value: initialData,
      querySourceId: selectedDataSourceId,
      expressionConfig: constants.EXPRESSION_SELECTION.REPORT_PART,
      requireLabel: props.requireLabel,
      reportDesignerStore: props.fieldStore.reportStore
    });
  }

  /**
   * Reset default value.
   * @param {Object} props
   * @param {Object} e
   */
  function fnResetDefaultValue(props, e) {
    if (props.fnResetDefaultValue) {
      props.fnResetDefaultValue();
      props.onChange && props.onChange();
    }
  }

  module.exports = CalculatedFieldPropertiesAction;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.CalculatedFieldPropertiesAction.js